<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="w-100 text-center text-primary">
                    <i class="fa fa-file-o text-primary mr-2"></i>
                    Listado de Recibos
                </h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                        Recibos
                        <div>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm mr-2"
                                @click="exportReceipts('csv')">
                                <i class="fa fa-download"></i> CSV
                            </button>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm"
                                @click="exportReceipts('xlsx')">
                                <i class="fa fa-download"></i> Excel
                            </button>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm ml-2"
                                @click="exportReceipts('pdf')">
                                <i class="fa fa-download"></i> PDF
                            </button>
                        </div>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col cols="10">
                            <b-row>
                                <b-col cols="3">
                                    <receipt-status-selector
                                        id="status"
                                        v-model="search.status"
                                        :allowEmpty="true"></receipt-status-selector>
                                </b-col>
                                <b-col cols="3">
                                   <month-and-year-selector
                                        v-model="search.issueDate"
                                        :allowEmpty="true"></month-and-year-selector>
                                </b-col>
                                <b-col cols="3">
                                    <b-input id="consignmentCode" type="text" v-model="search.consignmentCode" placeholder="Código Remesa">
                                    </b-input>
                                </b-col>
                                <b-col cols="3">
                                    <v-date-picker
                                        :input-props='{ class: "input", placeholder: "Fecha presentación" }'
                                        id="createdAt"
                                        v-model="search.createdAt"
                                        :max-date="new Date()"
                                        class="date-picker-w-100 date-picker-custom-border">
                                    </v-date-picker>
                                </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col cols="3">
                                    <common-agreement-selector
                                        id="commonAgreement"
                                        v-model="search.commonAgreement"
                                        :allowEmpty="true">
                                    </common-agreement-selector>
                                </b-col>
                                <b-col cols="3">
                                    <b-input id="bankReturnDocumentHeaderId" type="text" v-model="search.bankReturnDocumentHeaderId" placeholder="Sepa devolución">
                                    </b-input>
                                </b-col>
                                <b-col cols="6">
                                    <vue2-date-picker
                                        v-model="search.bankReturnCreatedAtDates"
                                        type="date"
                                        range
                                        :format="`DD/MM/YYYY`"
                                        lang="es"
                                        placeholder="Rango de Fechas devolución"
                                        :editable="false"
                                        :first-day-of-week="1"
                                        :shortcuts="datepicker.shortcuts"
                                        class="w-100 date-picker-w-100 date-picker-custom-border">
                                    </vue2-date-picker>
                                </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col cols="2">
                                    <b-input id="memberCode" type="text" v-model="search.memberCode" placeholder="Código de socio">
                                    </b-input>
                                </b-col>
                                <b-col cols="3">
                                    <b-input id="memberName" type="text" v-model="search.memberName" placeholder="Nombre de socio">
                                    </b-input>
                                </b-col>
                                <b-col cols="3">
                                    <b-input id="memberSurname" type="text" v-model="search.memberSurname" placeholder="Apellidos de socio">
                                    </b-input>
                                </b-col>
                                <b-col cols="2">
                                    <b-input id="amountMajor" type="text" v-model="search.amountMajor" placeholder="Importe >=">
                                    </b-input>
                                </b-col>
                                <b-col cols="2">
                                    <b-input id="amountMinor" type="text" v-model="search.amountMinor" placeholder="Importe <=">
                                    </b-input>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col cols="2">
                            <div class="d-flex flex-row-reverse">
                                <button
                                    class="btn btn-pill btn-primary px-4"
                                    @click="searchReceipts">
                                    Filtrar
                                </button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <v-server-table
                                ref="ReceiptsTable"
                                class="dataTable"
                                md="12"
                                lg="12"
                                sm="12"
                                :columns="columns"
                                :options="options"
                                :theme="theme"
                                @sorted="tableSorted">

                                <template slot="select" slot-scope="props">
                                    <input type="checkbox" :value="props.row.uuid" v-model="selectedReceipts">
                                </template>

                                <template slot="uuid" slot-scope="props">
                                    <router-link
                                        v-if="mixinCheckPermission('RECEIPT_EDIT') && !!props.row.isEditable() && props.row.status !== 'CHARGED' || props.row.status === 'CANCELED'"
                                        v-b-tooltip.hover.top
                                        title="Editar"
                                        :to="{ name: 'editReceipt', params: { uuid: props.row.uuid  }}">
                                        <i class="fa fa-pencil"></i>
                                    </router-link>

                                    <button
                                        v-if="mixinCheckPermission('RECEIPT_PRINT')"
                                        v-b-tooltip.hover.top
                                        title="Imprimir"
                                        class="btn p-0 ml-1"
                                        @click="openPrintReceiptModal(props.row.uuid)">
                                        <i class="fa fa-print"></i>
                                    </button>
                                </template>

                                <template slot="consignment" slot-scope="props">
                                    {{ props.row.consignment.code }}
                                </template>

                                <template slot="memberReceiptIssueDate" slot-scope="props">
                                    <span v-if="props.row.member.receiptIssueDate == 1">Enero</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 2">Febrero</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 3">Marzo</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 4">Abril</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 5">Mayo</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 6">Junio</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 7">Julio</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 8">Agosto</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 9">Septiembre</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 10">Octubre</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 11">Noviembre</span>
                                    <span v-else-if="props.row.member.receiptIssueDate == 12">Diciembre</span>
                                </template>

                                <template slot="activatedAt" slot-scope="props">
                                    {{ new Date(props.row.member.activatedAt) | dateFormat('DD/MM/YYYY')  }}
                                </template>

                                <template slot="chargedAt" slot-scope="props" v-if="props.row.chargedAt !== null">
                                    {{ new Date(props.row.chargedAt) | dateFormat('DD/MM/YYYY') }}
                                </template>

                                <template slot="chargedAt" v-else>
                                </template>

                                <template slot="memberCode" slot-scope="props">
                                    {{ props.row.member.code }}
                                </template>

                                <template slot="member" slot-scope="props">
                                    {{ props.row.member.fullName }}
                                </template>

                                <template slot="amount" slot-scope="props">
                                    {{ props.row.amount }} &euro;
                                </template>

                                <template slot="status" slot-scope="props">
                                    {{ props.row.getStatusName() }}
                                </template>

                                <template slot="chargeFromDate" slot-scope="props" v-if="props.row.chargeFromDate !== null ">
                                    {{ new Date(props.row.chargeFromDate) | dateFormat('DD/MM/YYYY') }}
                                </template>

                                <template slot="chargeFromDate" v-else>
                                </template>

                                <template slot="type" slot-scope="props">
                                    <payment-method-name :value="props.row.type"></payment-method-name>
                                </template>
                                
                                <template slot="documentHeaderDate" slot-scope="props" v-if="props.row.bankReturnDocumentHeaderDate !== null">
                                  {{ new Date(props.row.bankReturnDocumentHeaderDate) | dateFormat('DD/MM/YYYY') }}
                                </template>

                                <template slot="documentHeaderDate" v-else>
                                </template>

                                <template slot="afterFilter">
                                    <b-row>
                                        <b-col>
                                            <!-- :blockDeleteReceipt="props.row.status === 'POSTED'" --> <!-- TODO: validate status to block deleted -->
                                            <consignment-overview-actions-selector
                                                v-model="actionsSelector"
                                                :allowEmpty="true"
                                                :extraOptions="true"
                                                :receipts="receiptsSelected"
                                                :selectedReceipts="selectedReceipts"
                                                :receiptDeletePermission="!!mixinCheckPermission('RECEIPT_DELETE')"
                                                @selected-action="selectedAction">
                                            </consignment-overview-actions-selector>
                                        </b-col>
                                        <b-col>
                                            <div v-if="!!selectedReceipts.length" class="selected-receipts"><i class="fa fa-check" aria-hidden="true"></i>Recibos seleccionados: <span class="number">{{ selectedReceipts.length }}</span></div>
                                        </b-col>
                                    </b-row>
                                </template>

                            </v-server-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-modal
            ref="printReceiptModal"
            hide-footer
            size="sm"
            title="Imprimir Recibo"
            class="text-center"
            @hidden="printReceiptModalClosed">
            <b-row>
                <b-col class="text-left">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="receiptToPrint.specifyExpeditionDate"
                        name="hide">Especificar fecha de expedición
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row v-if="!!receiptToPrint.specifyExpeditionDate" class="mt-3">
                <b-col>
                    <v-date-picker
                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                        v-model="receiptToPrint.expeditionDate">
                    </v-date-picker>
                </b-col>
            </b-row>

            <b-row v-if="!!receiptToPrint.uuid" class="mt-3">
                <b-col class="d-flex flex-row-reverse">
                    <button
                        class="btn btn-brand btn-primary btn-lg"
                        :disabled="!!receiptToPrint.specifyExpeditionDate && !receiptToPrint.expeditionDate"
                        @click="printReceipt(receiptToPrint.uuid, receiptToPrint.expeditionDate)">
                        Imprimir
                    </button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {ServerTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {downloadJsonAsPdf} from '@/helpers/js-pdf';
    import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
    import { getReceipts, deleteReceipts, printReceipt, chargeReceiptByBank, cancelReceipt } from '@/api/receipt-api';
    import paymentMethodName from '@/components/clients/members/PaymentMethodName';
    import receiptStatusSelector from '@/components/consignments/receipts/ReceiptStatusSelector';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import monthAndYearSelector from '@/components/MonthAndYearSelector';
    import consignmentOverviewActionsSelector from '@/components/actions/ConsignmentOverviewActionsSelector';
    import Vue2DatePicker from 'vue2-datepicker';
    import CommonAgreementSelector from '@/components/agreements/CommonAgreementSelector';

    Vue.use(ServerTable);

    export default {
        name: "ListReceipts",
        components: {
            paymentMethodName,
            receiptStatusSelector,
            monthAndYearSelector,
            consignmentOverviewActionsSelector,
            Vue2DatePicker,
            'v-date-picker': DatePicker,
            CommonAgreementSelector,
        },
        data() {
            return {
                topmenu: [
                    {
                        name: 'Crear Recibo',
                        path: '/accounting/receipts/add',
                        brand: 'fa fa-industry'
                    }
                ],
                columns: ['select', 'uuid', 'code', 'memberReceiptIssueDate', 'activatedAt', 'chargedAt', 'consignment', 'memberCode', 'member', 'amount', 'status', 'chargeFromDate', 'type', 'documentHeaderDate'],
                options: {
                    headings: {
                        select: {
                            text: ''
                        },
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        code: 'Código',
                        memberReceiptIssueDate: 'Mes de emisión',
                        activatedAt: 'Fecha alta de socio',
                        chargedAt: 'Fecha de cargo',
                        consignment: 'Remesa',
                        memberCode: 'Código de socio',
                        member: 'Socio',
                        amount: 'Importe',
                        status: 'Estado',
                        chargeFromDate: 'Fecha de cobro',
                        type: 'Tipo',
                        documentHeaderDate: 'Fecha de Devolución',
                    },
                    columnsClasses: {
                        uuid: "fit normal-query"
                    },
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    perPageValues: [10, 25, 50, 100, 500, 1000, 10000],
                    sortable: ['code', 'memberReceiptIssueDate', 'activatedAt', 'chargedAt', 'consignment', 'memberCode', 'member', 'amount', 'status', 'chargeFromDate', 'type', 'documentHeaderDate'],
                    filterable: false,
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    },
                    requestFunction:  async (data) => {
                        if (this.$store.getters.getFilters[0] !== null) {
                          this.search.status = this.$store.getters.getFilters[0];
                        }
                        if (this.$store.getters.getFilters[1] !== null) {
                          this.search.issueDate = this.$store.getters.getFilters[1];
                        }
                        if (this.$store.getters.getFilters[2] !== null) {
                          this.search.consignmentCode = this.$store.getters.getFilters[2];
                        }
                        if (this.$store.getters.getFilters[3] !== null) {
                          this.search.createdAt = this.$store.getters.getFilters[3];
                        }
                        if (this.$store.getters.getFilters[4] !== null) {
                          this.search.commonAgreement = this.$store.getters.getFilters[4];
                        }
                        if (this.$store.getters.getFilters[5] !== null) {
                          this.search.bankReturnDocumentHeaderId = this.$store.getters.getFilters[5];
                        }
                        if (this.$store.getters.getFilters[6] !== null) {
                          this.search.bankReturnCreatedAtDates = this.$store.getters.getFilters[6];
                        }
                        if (this.$store.getters.getFilters[7] !== null) {
                          this.search.memberCode = this.$store.getters.getFilters[7];
                        }
                        if (this.$store.getters.getFilters[8] !== null) {
                          this.search.memberName = this.$store.getters.getFilters[8];
                        }
                        if (this.$store.getters.getFilters[9] !== null) {
                          this.search.memberSurname = this.$store.getters.getFilters[9];
                        }
                        if (this.$store.getters.getFilters[10] !== null) {
                          this.search.amountMajor = this.$store.getters.getFilters[10];
                        }
                        if (this.$store.getters.getFilters[11] !== null) {
                          this.search.amountMinor = this.$store.getters.getFilters[11];
                        }
                        this.search.page = data.page;
                        this.search.itemsPerPage = data.limit;
                        const response = await getReceipts(this.searchData);
                        this.receipts = response.receipts;
                        this.deselectAllReceipts();
                        return response;
                    },
                    responseAdapter: (data) => {
                        return {
                            data: data.receipts,
                            count: data.count
                        }
                    },
                },
                theme: 'bootstrap4',
                search: {
                    page: 1,
                    itemsPerPage: 50,
                    issueDate: null,
                    status: null,
                    consignmentCode: null,
                    createdAt: null,
                    commonAgreement: null,
                    bankReturnDocumentHeaderId: null,
                    memberCode: null,
                    memberName: null,
                    memberSurname: null,
                    amountMajor: null,
                    amountMinor: null
                },
                orderBy: {
                    column: null,
                    ascending: null
                },
                count: 0,
                datepicker: {
                    shortcuts: [
                        {
                            text: 'Hoy',
                            onClick: () => {
                                let dateStart = new Date();
                                dateStart.setHours(0, 0, 0);
                                let dateEnd = new Date();
                                dateEnd.setHours(23, 59, 59);
                                this.search.bankReturnCreatedAtDates = [dateStart, dateEnd]
                            }
                        },
                        {
                            text: 'Últimos 7 días',
                            onClick: () => {
                                let days = 7;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.search.bankReturnCreatedAtDates = [last, today]
                            }
                        },
                        {
                            text: 'Últimos 30 días',
                            onClick: () => {
                                let days = 30;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.search.bankReturnCreatedAtDates = [last, today]
                            }
                        }
                    ]
                },
                receiptToPrint: {
                    uuid: null,
                    specifyExpeditionDate: false,
                    expeditionDate: null
                },
                receiptFilters: {
                    code: null,
                    periodicity: null,
                    type: null,
                    cnae: null
                },
                actionsSelector : null,
                receiptToPrint: {
                    uuid: null,
                    specifyExpeditionDate: false,
                    expeditionDate: null
                },
                showAddReceiptsComponent: false,
                selectedReceipts: [],
                isAllReceiptsSelected: false,
                receipts: []
            }
        },
        created() {
            this.$_loadingMixin_showLoading();
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);

            Event.$on('vue-tables.loading', (data) => {
                this.$_loadingMixin_showLoading();
                this.count = 0;
            });
            Event.$on('vue-tables.loaded', (data) => {
                if (!!data && !!data.count) {
                    this.count = data.count;
                }
                this.$_loadingMixin_hideLoading();
            });
        },
        computed: {
            searchData() {
                let data = {
                    page: this.search.page,
                    itemsPerPage: this.search.itemsPerPage,
                };

                if (!!this.search.issueDate) {
                    this.search.issueDate.setDate(this.search.issueDate.getDate() + 1);

                    data['issueDate'] = this.search.issueDate.toISOString();
                }
                if (!!this.search.status) {
                    data['status'] = this.search.status;
                }

                if (!!this.orderBy.column) {
                    data['orderColumn'] = this.orderBy.column;
                }
                data['orderAscending'] = this.orderBy.ascending ? 1 : 0;

                if (!!this.search.memberCode) {
                    data['memberCode'] = this.search.memberCode;
                }

                if (!!this.search.memberName) {
                    data['memberName'] = this.search.memberName;
                }

                if (!!this.search.memberSurname) {
                    data['memberSurname'] = this.search.memberSurname;
                }

                if (!!this.search.createdAt) {
                    this.search.createdAt.setDate(this.search.createdAt.getDate() + 1);

                    data['createdAt'] = this.search.createdAt.toISOString();
                }

                if (!!this.search.consignmentCode) {
                    data['consignmentCode'] = this.search.consignmentCode;
                }

                if (!!this.search.bankReturnDocumentHeaderId) {
                    data['bankReturnDocumentHeaderId'] = this.search.bankReturnDocumentHeaderId;
                }

                if (
                    Array.isArray(this.search.bankReturnCreatedAtDates)
                    && this.search.bankReturnCreatedAtDates.length === 2
                    && this.search.bankReturnCreatedAtDates[0] != null
                    && this.search.bankReturnCreatedAtDates[1] != null
                ) {
                    this.search.bankReturnCreatedAtDates[0].setDate(this.search.bankReturnCreatedAtDates[0].getDate() + 1);
                    this.search.bankReturnCreatedAtDates[1].setDate(this.search.bankReturnCreatedAtDates[1].getDate() + 1);

                    data['bankReturnCreatedAtStartDate'] = this.search.bankReturnCreatedAtDates[0].toISOString();
                    data['bankReturnCreatedAtEndDate'] = this.search.bankReturnCreatedAtDates[1].toISOString();
                }

                if (!!this.search.commonAgreement) {
                    data['commonAgreementId'] = this.search.commonAgreement.uuid;
                }

                if (!!this.search.amountMajor) {
                    data['amountMajor'] = this.search.amountMajor;
                }

                if (!!this.search.amountMinor) {
                    data['amountMinor'] = this.search.amountMinor;
                }

                return data;
            },
            receiptsSelected() {
                if (Array.isArray(this.receipts)) {
                    let receipts = this.receipts;

                    return receipts;
                } else {
                    return [];
                }
            }
        },
        methods: {
            searchReceipts() {
                let filterData = [];
                filterData.push(this.search.status);
                filterData.push(this.search.issueDate);
                filterData.push(this.search.consignmentCode);
                filterData.push(this.search.createdAt);
                filterData.push(this.search.commonAgreement);
                filterData.push(this.search.bankReturnDocumentHeaderId);
                filterData.push(this.search.bankReturnCreatedAtDates);
                filterData.push(this.search.memberCode);
                filterData.push(this.search.memberName);
                filterData.push(this.search.memberSurname);
                filterData.push(this.search.amountMajor);
                filterData.push(this.search.amountMinor);
                this.$store.commit('SET_FILTERS_LIST', filterData);
                this.$refs.ReceiptsTable.refresh();
            },
            async exportReceipts(format) {
                if (this.count > 0) {
                    this.$_loadingMixin_showLoading();

                    let parameters = Object.assign({}, this.searchData);
                    parameters.page = 1;
                    parameters.itemsPerPage = this.count;

                    let response = await getReceipts(parameters);

                    let rows = response.receipts.map((receipt) => {
                        return this.normalizeReceipts(receipt);
                    });

                    if (format === 'csv') {
                        downloadJsonAsCsv(rows);
                    } else if (format === 'xlsx') {
                        downloadJsonAsXlsx(rows);
                    } else if (format === 'pdf') {
                        downloadJsonAsPdf(rows);
                    }

                    this.$_loadingMixin_hideLoading();
                }
            },
            normalizeReceipts(receipt) {
                return {
                    'Código': receipt.code,
                    'Mes de emisión': receipt.member.receiptIssueDate,
                    'Fecha de presentación': receipt.createdAt.toLocaleDateString(),
                    'Fecha de cargo': (receipt.chargedAt) ? receipt.chargedAt.toLocaleDateString() : null,
                    'Remesa': receipt.consignment.code,
                    'Código de socio': receipt.member.code,
                    'Socio': receipt.member.fullName,
                    'Importe': receipt.amount,
                    'Estado': receipt.status,
                    'Tipo': receipt.type,
                    'Fecha de Devolución': (receipt.bankReturnDocumentHeaderDate) ? receipt.bankReturnDocumentHeaderDate.toLocaleDateString() : null
                };
            },
            tableSorted(data) {
                this.orderBy.column = data.column;
                this.orderBy.ascending = data.ascending;
            },
            async printReceipt(uuid, expeditionDate) {
                this.$_loadingMixin_showLoading();
                let date = !!expeditionDate ? expeditionDate.toISOString() : null;
                await printReceipt(uuid, date)
                    .then((dataStream) => {
                        window.open(URL.createObjectURL(dataStream));
                    })
                    .catch(() => {
                        this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del documento");
                    });
                this.$_loadingMixin_hideLoading();
            },
            openPrintReceiptModal(uuid) {
                this.receiptToPrint.uuid = uuid;
                this.$refs.printReceiptModal.show();
            },
            printReceiptModalClosed() {
                this.receiptToPrint.uuid = null;
                this.receiptToPrint.specifyExpeditionDate = false;
                this.receiptToPrint.expeditionDate = null;
            },
            selectedAction(action) {
                switch (action.action) {
                    case 'Seleccionar todos':
                        this.selectReceipts();
                        break;
                    case 'Deseleccionar todos':
                        this.deselectAllReceipts();
                        break;
                    case 'Eliminar':
                        this.deleteReceipts(this.selectedReceipts);
                        break;
                    case 'Cobrar sin llamar':
                        this.chargeReceiptByBank(action.value, false);
                        break;
                    case 'Anular / Condonar':
                        this.cancelReceipt();
                        break;
                }
            },
            selectReceipts() {
                this.selectedReceipts = []
                if (!this.isAllReceiptsSelected) {
                    for (let i in this.receipts) {
                        this.selectedReceipts.push(this.receipts[i].uuid);
                    }
                }
            },
            deselectAllReceipts() {
                this.selectedReceipts = [];
            },
            deleteReceipts(uuids) {
                let partialTitle = (uuids.length == 1) ? 'el recibo seleccionado' : uuids.length + ' recibos';
                let successfulMessage = (uuids.length == 1) ? 'El recibo ha sido eliminado' : uuids.length + ' recibos han sido eliminados';
                let errorMessage = (uuids.length == 1) ? 'No se ha podido eliminar el recibo' : 'No se han podido eliminar los recibos';
                document.activeElement.blur();
                swal({
                    title: '¿Desea eliminar ' + partialTitle + '?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        deleteReceipts(uuids)
                            .then(() => {
                                this.removeReceiptsFromReceipts();
                                this.$_notificationMixin_success('Operación completada', successfulMessage);
                                this.$_loadingMixin_hideLoading();
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', errorMessage);
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            removeReceiptsFromReceipts() {
                this.searchReceipts();
            },
            async chargeReceiptByBank(chargeDate, memberCalled) {
                for (const uuid of this.selectedReceipts) {
                    this.$_loadingMixin_showLoading();
                    await chargeReceiptByBank(uuid, chargeDate, memberCalled)
                        .then((receipt) => {
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Operación no completada', 'No se ha podido aplicar el tratamiento');
                        });
                    this.$_notificationMixin_success('Operación completada', 'Recibos tratado con éxito');
                    this.$_loadingMixin_hideLoading();
                }
            },
            async cancelReceipt() {
                for (const uuid of this.selectedReceipts) {
                    console.log('cancelReceipt', uuid);
                    this.$_loadingMixin_showLoading();
                    await cancelReceipt(uuid)
                        .then((response) => {})
                        .catch(() => {
                            this.$_notificationMixin_error('Operación no completada', 'No se ha podido aplicar el tratamiento');
                        });
                    this.$_notificationMixin_success('Operación completada', 'Recibos tratado con éxito');
                }
            },
        },
        watch: {
            'receiptToPrint.specifyExpeditionDate': function () {
                if (!this.receiptToPrint.specifyExpeditionDate) {
                    this.receiptToPrint.expeditionDate = null;
                }
            }
        }
    }
</script>

<style>
    .pointer {
        cursor: pointer;
    }

    .VueTables .VueTables__search {
        width: calc(66.6% + 20px);
    }

    .VueTables .VueTables__search .row {
        width: 100%;
    }

    .selected-receipts {
        padding: 7px;
        background-color: #41b883;
        color: #ffffff;
        border-radius: 5px;
    }

    .selected-receipts i {
        margin-right: 7px;
    }

    .selected-receipts .number {
        padding-left: 5px;
        font-weight: bold;
    }

    .date-picker-custom-border input[type="text"] {
        color: #5c6873 !important;
        /* background-color: #fff; */
        /* background-clip: padding-box; */
        border: 1px solid #e4e7ea !important;
        /* border-radius: 0.25rem; */
    }

    .col-auto {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
</style>
